import { render, staticRenderFns } from "./FeaturedMedia.vue?vue&type=template&id=1107e9d2&scoped=true"
import script from "./FeaturedMedia.vue?vue&type=script&lang=js"
export * from "./FeaturedMedia.vue?vue&type=script&lang=js"
import style0 from "./FeaturedMedia.vue?vue&type=style&index=0&id=1107e9d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1107e9d2",
  null
  
)

export default component.exports